export default __webpack_public_path__ + "static/media/everis.82002322.png";